import React from 'react';
import { AND, OR } from "../../../misc/RuleObjectTypes";

const FilterOperator = ({ element, position, reduceFilters }) => {
  return (
    <div className="filter-op">
      <select
        className='form-select drop-down-dm tw-w-[8%]'
        value={element.value}
        onChange={(ev) => {
          reduceFilters({
            type: "UPDATE_OP",
            position: position,
            value: ev.target.value,
          });
        }}
      >
        <option value={AND}>And</option>
        <option value={OR}>Or</option>
      </select>
    </div>
  );
};
export default FilterOperator;
